import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

// CONFIG
import {gaConfig} from '@stencil/hotels-config';
// SELECTORS
import {roomFiltersDropdownSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';
// ICONS
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';

// STYLES
import * as S from './Filter.styles';

const {DetailsGAClickEventActions} = gaConfig;

const Filter = ({
  setFilters,
  currentFilters = [],
  roomFilterList = [],
  customOuterWrapperPadding = null,
  customInnerWrapperPadding = null,
  hideCheckBox = false,
  isActive = false,
  textColor = null,
  isGroupFilters = false,
  setIsClearAllButtonClicked,
}: // groupFilterAppliedList = [],
{
  setFilters: Function;
  currentFilters: any;
  roomFilterList?: Array<any>;
  customOuterWrapperPadding?: string;
  customInnerWrapperPadding?: string;
  hideCheckBox?: boolean;
  isActive?: boolean;
  textColor?: string;
  isGroupFilters?: boolean;
  setIsClearAllButtonClicked?: Function;
  // groupFilterAppliedList: Array<any>;
}) => {
  const roomsFilterData =
    roomFilterList && roomFilterList?.length > 0
      ? roomFilterList
      : useSelector(roomFiltersDropdownSelector);
  const [showTooltip, setShowTooltip] = useState(false);

  const dispatch = useDispatch();

  const handleToogleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  if (!roomsFilterData.length) {
    return null;
  }

  return (
    <>
      <S.OuterWrapperDiv
        id={FilterWrapperId}
        customOuterWrapperPadding={customOuterWrapperPadding}
        isActive={isActive}
      >
        <S.InnerWrapperDiv
          customInnerWrapperPadding={customInnerWrapperPadding}
          isGroupFilters={isGroupFilters}
        >
          {roomsFilterData.map((currentIterationFilter, index: string) => {
            if (!currentIterationFilter?.title) return;
            return (
              <S.ItemWrapperDiv
                key={`${currentIterationFilter?.title}-${index}`}
                onClick={e => {
                  e.stopPropagation();
                  setTimeout(() => {
                    if (hideCheckBox) {
                      setFilters(prevFilters => {
                        const alreadyPresent = prevFilters.some(
                          filter => filter?.title === currentIterationFilter?.title,
                        );

                        return alreadyPresent
                          ? prevFilters.filter(
                              filter => filter?.title !== currentIterationFilter?.title,
                            )
                          : [...prevFilters, currentIterationFilter];
                      });
                    }
                  }, 0);
                }}
              >
                {!hideCheckBox ? (
                  <S.StyledCheckBox
                    id={currentIterationFilter?.title}
                    checked={currentFilters.some(
                      filter => filter?.code === currentIterationFilter?.code,
                    )}
                    onChange={e => {
                      setTimeout(() => {
                        setFilters(prevFilters => {
                          const alreadyPresent = prevFilters.some(
                            filter => filter?.title === currentIterationFilter?.title,
                          );

                          return alreadyPresent
                            ? prevFilters.filter(
                                filter => filter?.title !== currentIterationFilter?.title,
                              )
                            : [...prevFilters, currentIterationFilter];
                        });
                      }, 0);

                      // setIsClearAllButtonClicked(false);
                    }}
                    data-testid="detail-roomSelection-filter-input"
                    onMouseOver={() => handleToogleTooltip()}
                    onMouseOut={() => handleToogleTooltip()}
                  />
                ) : null}

                {currentIterationFilter?.title && (
                  <S.TextStyledSpan
                    htmlFor={currentIterationFilter.title}
                    isBold={false}
                    textColor={textColor}
                  >
                    {currentIterationFilter.title}{' '}
                  </S.TextStyledSpan>
                )}
                {isActive && (
                  <HappyCloseIcon
                    fill={textColor}
                    height={'1rem'}
                    width={'1rem'}
                    margin={'0 0 0 10px'}
                  />
                )}
                {showTooltip && (currentIterationFilter?.sta || currentIterationFilter?.sta) && (
                  <S.TooltipDiv>
                    <span className="arror-up"></span>
                    {currentFilters.some(filter => filter?.code === currentIterationFilter?.code)
                      ? currentIterationFilter?.sta
                      : currentIterationFilter?.sti}
                    <span className="cm__modalClose"></span>
                  </S.TooltipDiv>
                )}
              </S.ItemWrapperDiv>
            );
          })}
        </S.InnerWrapperDiv>
      </S.OuterWrapperDiv>
    </>
  );
};

export default Filter;
export const FilterWrapperId = 'details-filters-outer-wrapper';
